webpackJsonp([186893512645253],{

/***/ 157:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ramda = __webpack_require__(23);
	
	var _ramda2 = _interopRequireDefault(_ramda);
	
	var _classnames = __webpack_require__(33);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _recompose = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var getDifficulty = _ramda2.default.compose(function (arr) {
	  return _ramda2.default.times(function (i) {
	    return _ramda2.default.propOr(false, i, arr);
	  }, 3);
	}, _ramda2.default.map(function () {
	  return true;
	}), _ramda2.default.range(0), _ramda2.default.pathOr(null, ['difficulty']));
	
	var Difficulty = function Difficulty(_ref) {
	  var _classNames;
	
	  var difficulty = _ref.difficulty,
	      className = _ref.className;
	  return _react2.default.createElement(
	    'ul',
	    {
	      className: (0, _classnames2.default)((_classNames = {
	        'my0 list-reset flex': true
	      }, _classNames[className] = className, _classNames))
	    },
	    difficulty.map(function (star) {
	      return _react2.default.createElement('li', {
	        className: (0, _classnames2.default)({
	          'mr1 star': true,
	          'filled': star
	        })
	      });
	    })
	  );
	};
	
	var enhance = (0, _recompose.mapProps)(function (_ref2) {
	  var frontmatter = _ref2.frontmatter,
	      props = _objectWithoutProperties(_ref2, ['frontmatter']);
	
	  return _extends({
	    difficulty: getDifficulty(frontmatter)
	  }, props);
	});
	
	exports.default = enhance(Difficulty);
	module.exports = exports['default'];

/***/ }),

/***/ 347:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(63);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(57);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _ramda = __webpack_require__(23);
	
	var _ramda2 = _interopRequireDefault(_ramda);
	
	var _enhancers = __webpack_require__(126);
	
	var _Difficulty = __webpack_require__(157);
	
	var _Difficulty2 = _interopRequireDefault(_Difficulty);
	
	var _Title = __webpack_require__(125);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BlogPostTemplate = function BlogPostTemplate(_ref) {
	  var frontmatter = _ref.frontmatter,
	      html = _ref.html,
	      siteTitle = _ref.siteTitle,
	      image = _ref.image;
	  return _react2.default.createElement(
	    'div',
	    { className: 'max-width-2 mx-auto px2 mb3' },
	    _react2.default.createElement(_reactHelmet2.default, { title: frontmatter.title + ' | ' + siteTitle }),
	    _react2.default.createElement(
	      _Title2.default,
	      null,
	      frontmatter.title
	    ),
	    _react2.default.createElement(_Difficulty2.default, {
	      frontmatter: frontmatter,
	      className: 'mb2'
	    }),
	    _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: html } }),
	    image && _react2.default.createElement('img', {
	      src: image,
	      className: 'fit block'
	    })
	  );
	};
	
	exports.default = (0, _enhancers.postsEnhancer)(BlogPostTemplate);
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-area-js-68e702d99cae83189c56.js